import { useEffect, useState, useRef } from "react";
import { Dropdown, Button, Form } from "react-bootstrap";
import { ChevronRight } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { occupiedAuditTrailBedsList } from "../../../../store/actions/bedsAction";
import TableDesign from "../../../common/table/TableDesign";
import { useParams } from "react-router-dom";
import DeleteWardPopup from "../DeleteWardPopup";
import ToggelActivatateWardPopup from "../ToggelActivatateWardPopup";
import ShowWardUrlPopup from "../ShowWardUrlPopup";
import ManageWard from "../../../../pages/ManageWard";
import { resetPopup } from "../../../../store/reducerSlice/beds";
import envalope from "../../../../assets/images/envalope.png";
import download from "../../../../assets/images/download.png";
import black from "../../../../assets/images/black.png";
import red from "../../../../assets/images/red.png";
import darkYellow from "../../../../assets/images/darkYellow.png";
import yellow from "../../../../assets/images/yellow.png";
import download2 from "../../../../assets/images/download2.png";
import beds from "../../../../store/reducerSlice/beds";
const tableHeadings = [
  {
    label: "S. No.",
  },
  {
    label: "Geography",
  },

  {
    label: "Person Email",
    sort: "email"
  },
  {
    label: "Date & Time",
  },

  {
    label: "Operations",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const AuditTrailBed = () => {
  const { bedId } = useParams();
  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState("all");
  const [selectWard, setSelectWard] = useState(null);
  const [selectClient, setselectClient] = useState(null);
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();
  const [activeTab, setActiveTab] = useState("");
  const searchInputRef = useRef(null);
  const [filterOption, setFilterOption] = useState({
    page: 1,
    search: "",
    orderBy: "created",
    orderIn: -1,
    bedId:bedId
  });
  const [deleteRec, setDeleteRec] = useState(null);
  const [wardLink, setWardLink] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [wardLinkModalShow, setWardLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { auditTrails, filtered, pagination, isLoader, isRecordUpdated } =
    useSelector((state) => {
      return state.beds;
    });
  const page = pagination?.currentPage;

  const cc = filtered || auditTrails;

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({ search: searchText, page: 1 });
    }
  }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    dispatch(occupiedAuditTrailBedsList(filterOption)).then(({ payload }) => {
      if (payload?.success) {
        console.log("payload?.data", payload?.data);
      }
    });
  }, [filterOption, isRecordUpdated]);

  // useEffect(() => {
  //   if (isRecordUpdated) {
  //     dispatch(occupiedAuditTrailBedsList({ bedId })).then(({ payload }) => {
  //       if (payload?.success) {
  //         console.log("payload?.data", payload?.data);
  //       }
  //     });
  //   }
  // }, [filterOption,isRecordUpdated]);

  

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const hideHandle = () => {
    setModalShow(false);
    setSelectWard(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWardLinkModalShow(false);
  };
  const createUpdateWard = (ward) => {
    dispatch(resetPopup());
    setModalShow(true);
    setselectClient(ward);
    setTitle("Update Ward");
    setMessage("Ward updated successfully!");
    setShowResult(true);
  };
  const addNewWard = () => {
    dispatch(resetPopup());
    setModalShow(true);
    setselectClient(null);
    setTitle("Add Ward");
    setMessage("Ward has been added successfully.");
    setShowResult(true);
  };
  const deleteEventHandler = (rec) => {
    setDeleteRec(rec?.bedId);
    setDeleteModalShow(true);
  };

  const wardLinkEventHandler = (rec) => {
    setWardLink(rec?.slug);
    setWardLinkModalShow(true);
  };

  const toggleActivateEventHandler = (rec) => {
    setToggleActivateRec(rec?.bedId);
    setToggleActivateStatus(rec?.status);
    setToggleActivateModalShow(true);
  };

  const formatedDate = (val) => {
    var options = { year: "numeric", month: "2-digit", day: "2-digit",hour12: true,  };
    return new Date(val).toLocaleDateString("nl-NL", options);
    
  };
  const formatedTime = (val) => {
    var options = { hour12: true, hour:'2-digit', minute:'2-digit' };
    return new Date(val).toLocaleTimeString("en-US", options);
    
  };

  const navigateTodetail = (val) => {
    navigate(`/ward-detail/${val.bedId}`);
  };

  const navigateToPreview = (val) => {
    navigate(`/preview-ward/${val.bedId}`, {
      state: { activeTab: activeTab },
      replace: true,
    });
  };

  return (
    <>
      <div className="container">
        <div className="d-flex justify-content-start align-content-center align-items-center py-2 my-2">
          <h1
            className="text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            Occupied Beds
          </h1>
          <ChevronRight className="arrowRight" />
          <h1 className="title text-secondary mt-1">Audit Trails</h1>
        </div>
        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: `List of Audit Trails `,
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td>

                    <td className="py-auto">{row.location}</td>
                    <td>{row.email}</td>
                    <td>{formatedDate(row.createdAt)}, {formatedTime(row.createdAt)}</td>
                    <td style={{ width: "240px" }}>{row.action}</td>
                  </tr>
                );
            })
          ) : (
            <tr>
              <td colSpan="8">No Result Found</td>
            </tr>
          )}
        </TableDesign>
      </div>
    </>
  );
};

export default AuditTrailBed;
